import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, ShowOnDirtyErrorStateMatcher, ErrorStateMatcher, MatCheckbox, MatCheckboxModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule, MatNativeDateModule, MatDialogModule, MatTooltipModule } from '@angular/material';
import { MatRadioModule } from '@angular/material/radio';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TextMaskModule } from 'angular2-text-mask';

import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoginParceiroComponent } from './login-parceiro/login-parceiro.component';
import { RedefinirSenhaComponent } from './login/redefinir-senha.component';
import { PrimeiroAcessoTokenComponent } from './login/primeiro-acesso-token.component';

import { AppRoutingModule } from './app-routing/app-routing.module';
import { HomeComponent } from './home/home.component';
import { BfPortalComponent } from './bf-portal/bf-portal.component';
import { MenuComponent } from './menu/menu.component';
import { HeaderComponent } from './header/header.component';

import { SegundaViaSelecaoComponent } from './bf-segundavia-cli/segundavia-selecao.component';
import { SegundaViaContratoComponent } from './bf-segundavia-cli/segundavia-contrato.component';
import { SegundaViaModalBoletoComponent } from './bf-segundavia-cli/segundavia-modal-boleto.component';
import { SegundaViaModalDebitoAutomaticoComponent } from './bf-segundavia-cli/segundavia-modal-debito-automatico.component';
import { EnderecoSelecaoComponent } from './bf-endereco-cli/endereco-selecao.component';
import { EnderecoDadosComponent } from './bf-endereco-cli/endereco-dados.component';
import { EnderecoConclusaoComponent } from './bf-endereco-cli/endereco-conclusao.component';
import { EnderecoModalBuscaComponent } from './bf-endereco-cli/endereco-modal-busca.component';
import { EnderecoModalConfirmarComponent } from './bf-endereco-cli/endereco-modal-confirmar.component';
import { SegundaviacarneSelecaoComponent } from './bf-segundaviacarne-cli/segundaviacarne-selecao.component';
import { SegundaViaCarneEnderecoComponent } from './bf-segundaviacarne-cli/segundaviacarne-endereco.component';
import { SegundaViaCarneConclusaoComponent } from './bf-segundaviacarne-cli/segundaviacarne-conclusao.component';
import { SegundaViaCarneModalEnderecoComponent } from './bf-segundaviacarne-cli/segundaviacarne-modal-endereco.component';
import { ExtratoSelecaoComponent } from './bf-extrato-cli/extrato-selecao.component';
import { ExtratoContratoComponent } from './bf-extrato-cli/extrato-contrato.component';
import { OutrosServicosComponent } from './bf-outros-servicos-cli/outros-servicos.component';
import { LiquidacaoSelecaoComponent } from './bf-liquidacao-cli/liquidacao-selecao.component';
import { LiquidacaoContratoComponent } from './bf-liquidacao-cli/liquidacao-contrato.component';
import { LiquidacaoContratoConclusaoComponent } from './bf-liquidacao-cli/liquidacao-contrato-conclusao.component';
import { LiquidacaoParcelasComponent } from './bf-liquidacao-cli/liquidacao-parcelas.component';
import { LiquidacaoParcelasConclusaoComponent } from './bf-liquidacao-cli/liquidacao-parcelas-conclusao.component';
import { LiquidacaoModalDetalhesComponent } from './bf-liquidacao-cli/liquidacao-modal-detalhes.component';
import { LiquidacaoModalConfirmarComponent } from './bf-liquidacao-cli/liquidacao-modal-confirmar.component';
import { LiquidacaoModalDadosBancariosComponent } from './bf-liquidacao-cli/liquidacao-modal-dados-bancarios.component';
import { CopiaContratoSelecaoComponent } from './bf-copia-contrato-cli/copia-contrato-selecao.component';
import { CopiaContratoModalDisponivelComponent } from './bf-copia-contrato-cli/copia-contrato-modal-disponivel.component';
import { CentralAtendimentoComponent } from './central-atendimento/central-atendimento.component';
import { CancelarProdutoAgregadoComponent } from './bf-cancelarproduto-cli/cancelar-produto-agregado.component';
import { CancelarProdutoModalDadosBancariosComponent } from './bf-cancelarproduto-cli/cancelar-produto-modal-dados-bancarios.component';

import { ParceirosComponent } from './parceiros/parceiros.component';
import { ErroComponent } from './erro/erro.component';
import { ErroPrimeiroacessoComponent } from './erro-primeiroacesso/erro-primeiroacesso.component';

import { SessaoService } from './services/sessao.service';
import { AuthguardGuard } from './services/authguard.guard';
import { PagamentoParcelaService } from './services/pagamento-parcela.service';
import { BraInputComponent } from './componentes/bra-input/bra-input.component';
import { BraPasswordComponent } from './componentes/bra-password/bra-password.component';
import { BraSelectComponent } from './componentes/bra-select/bra-select.component';
import { BraRadioComponent } from './componentes/bra-radio/bra-radio.component';
import { BraCheckboxComponent } from './componentes/bra-checkbox/bra-checkbox.component';
import { BraEmailComponent } from './componentes/bra-email/bra-email.component';
import { BraAlertComponent } from './componentes/bra-alert/bra-alert.component';
import { BraDateComponent } from './componentes/bra-date/bra-date.component';
import { BraMaskComponent } from './componentes/bra-mask/bra-mask.component';
import { RedirecionamentoComponent } from './redirecionamento/redirecionamento.component';
import { PrimeiroAcessoComponent } from './componentes/primeiro-acesso/primeiro-acesso.component';
import { BraConfirmComponent } from './componentes/bra-confirm/bra-confirm.component';
import { BraNumberComponent } from './componentes/bra-number/bra-number.component';
import { RelExtratoContratoComponent } from './componentes/rel-extrato-contrato/rel-extrato-contrato.component';
import { BraDateTextComponent } from './componentes/bra-date-text/bra-date-text.component';
import { HttpClientModule } from '@angular/common/http';
import { DebitoAutomaticoComponent } from './debito-automatico/debito-automatico.component';
import { DebitoAutomaticoContratoComponent } from './debito-automatico/debito-automatico-contrato.component';
import { DebitoAutomaticoContratoModalComponent } from './debito-automatico/debito-automatico-contrato-modal.component';
import { DebitoAutomaticoContratoConclusaoComponent } from './debito-automatico/debito-automatico-contrato-conclusao.component';
import { OpenBankingComponent } from './open-banking/open-banking.component';
import { BraRecaptchaComponent } from './componentes/bra-recaptcha/bra-recaptcha.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { BraAlertLiquidacaoComponent } from './componentes/bra-alert-liquidacao/bra-alert-liquidacao.component';
import { BraCountdownComponent } from './componentes/bra-countdown/bra-countdown.component';

import { AccountValidatorDirective } from './util/account-validator.directive';
import { CopiaContratoModalAvisoCentralComponent } from './bf-copia-contrato-cli/copia-contrato-modal-aviso-central.component';
import { CopiaContratoModalIndisponivelComponent } from './bf-copia-contrato-cli/copia-contrato-modal-indisponivel.component';
import { CopiaContratoModalSistemaIndisponivelComponent } from './bf-copia-contrato-cli/copia-contrato-modal-aviso-sistema-indisponivel.component';
import { LoginModalInvalidoComponent } from './login/login-modal-invalido';
import { RedefinirSenhaModalInvalidoComponent } from './login/redefinir-senha-modal-invalido';
import { DetalheParcelaComponent } from './bf-extrato-cli/components/detalhe-parcela/detalhe-parcela.component';

// export function countdownConfigFactory(): CountdownConfig {
//   return {};
// }

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginParceiroComponent,
    RedefinirSenhaComponent,
    PrimeiroAcessoTokenComponent,
    HomeComponent,
    BfPortalComponent,
    MenuComponent,
    HeaderComponent,
    SegundaViaSelecaoComponent,
    SegundaViaContratoComponent,
    SegundaViaModalBoletoComponent,
    SegundaViaModalDebitoAutomaticoComponent,
    EnderecoSelecaoComponent,
    EnderecoDadosComponent,
    EnderecoConclusaoComponent,
    EnderecoModalBuscaComponent,
    EnderecoModalConfirmarComponent,
    SegundaviacarneSelecaoComponent,
    SegundaViaCarneEnderecoComponent,
    SegundaViaCarneConclusaoComponent,
    SegundaViaCarneModalEnderecoComponent,
    ExtratoSelecaoComponent,
    ExtratoContratoComponent,
    OutrosServicosComponent,
    LiquidacaoSelecaoComponent,
    LiquidacaoContratoComponent,
    LiquidacaoContratoConclusaoComponent,
    LiquidacaoParcelasComponent,
    LiquidacaoParcelasConclusaoComponent,
    LiquidacaoModalDetalhesComponent,
    LiquidacaoModalConfirmarComponent,
    LiquidacaoModalDadosBancariosComponent,
    LoginModalInvalidoComponent,
    RedefinirSenhaModalInvalidoComponent,
    CopiaContratoSelecaoComponent,
    CopiaContratoModalDisponivelComponent,
    CopiaContratoModalAvisoCentralComponent,
    CopiaContratoModalIndisponivelComponent,
    CopiaContratoModalSistemaIndisponivelComponent,
    CentralAtendimentoComponent,
    CancelarProdutoAgregadoComponent,
    CancelarProdutoModalDadosBancariosComponent,
    ParceirosComponent,
    ErroComponent,
    BraInputComponent,
    BraPasswordComponent,
    BraSelectComponent,
    BraRadioComponent,
    BraCheckboxComponent,
    BraEmailComponent,
    BraAlertComponent,
    BraDateComponent,
    BraMaskComponent,
    RedirecionamentoComponent,
    PrimeiroAcessoComponent,
    BraConfirmComponent,
    BraNumberComponent,
    RelExtratoContratoComponent,
    BraDateTextComponent,
    DebitoAutomaticoComponent,
    DebitoAutomaticoContratoComponent,
    DebitoAutomaticoContratoModalComponent,
    DebitoAutomaticoContratoConclusaoComponent,
    OpenBankingComponent,
    BraRecaptchaComponent,
    BraAlertLiquidacaoComponent,
    RedefinirSenhaComponent,
    BraCountdownComponent,
    ErroPrimeiroacessoComponent,
    AccountValidatorDirective,
    DetalheParcelaComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    FormsModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatRadioModule,
    ReactiveFormsModule,
    TextMaskModule,
    Ng4LoadingSpinnerModule.forRoot(),
    HttpClientModule,
    NgxCaptchaModule
  ],
  entryComponents: [
    EnderecoModalConfirmarComponent,
    SegundaViaCarneModalEnderecoComponent,
    BraAlertComponent,
    BraAlertLiquidacaoComponent,
    BraConfirmComponent,
    CopiaContratoModalDisponivelComponent,
    CopiaContratoModalAvisoCentralComponent,
    CopiaContratoModalIndisponivelComponent,
    CopiaContratoModalSistemaIndisponivelComponent,
    LoginModalInvalidoComponent,
    RedefinirSenhaModalInvalidoComponent,
    SegundaViaCarneModalEnderecoComponent,
    EnderecoModalBuscaComponent,
    LiquidacaoModalDetalhesComponent,
    LiquidacaoModalConfirmarComponent,
    LiquidacaoModalDadosBancariosComponent,
    SegundaViaModalDebitoAutomaticoComponent,
    CancelarProdutoModalDadosBancariosComponent
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    SessaoService,
    AuthguardGuard,
    PagamentoParcelaService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/app.module.ts